class SystemService {
    public isOnline = true;
    public taskHelper;
    public app;
}

const systemService = new SystemService();

window.addEventListener("offline", function() {
    systemService.isOnline = false;
}, false);

window.addEventListener("online", function() {
    systemService.isOnline = true;
}, false);

export default systemService;
